export const CloseBanner = () => {
    const banner = document.getElementById("close-banner")
    if(!banner) { return; }
    banner.addEventListener("click", () => {
        document.getElementById("channels").style.top = "0px"
        document.getElementById("site-header").style.marginTop = "0px"
    })
  }